module.exports = __webpack_public_path__ + "img/Carshelp3.0.0546438d.png";